import { render, staticRenderFns } from "./panel-header.vue?vue&type=template&id=f6e54444"
import script from "./panel-header.vue?vue&type=script&lang=js"
export * from "./panel-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports